import { Types } from "@grandvisionhq/graphql";
import { getLiteralText } from "./get-literal-text.js";
const formatOptIns = (intl, formData, optIns, consents, groupedOptins = {}) => {
  const allOptIns = [
    ...optIns.map((optIn) => [optIn, ...optIn?.children ?? []]),
    ...consents.map((consent) => [...consent?.children ?? []])
  ].flatMap((optIn) => optIn).filter((optIn) => !optIn.doNotSubmit);
  const singleOptins = allOptIns.filter((optIn) => !groupedOptins.hasOwnProperty(optIn.value)).map((optIn) => ({
    id: optIn.value,
    value: formData?.[optIn.value] === "true",
    uiType: Types.UIType.CHECKBOX,
    literalText: intl.getFormattedLabel(getLiteralText(optIn.value, optIns) ?? "", {
      parseHTML: false,
      parseLink: true
    })
  }));
  const groupedOptinsArray = Object.entries(groupedOptins).flatMap(
    ([groupKey, ids]) => ids.map((id) => ({
      id,
      value: formData?.[groupKey] === "true",
      uiType: Types.UIType.CHECKBOX,
      literalText: intl.getFormattedLabel(getLiteralText(groupKey, optIns) ?? "", {
        parseHTML: false,
        parseLink: true
      })
    }))
  );
  return [...singleOptins, ...groupedOptinsArray];
};
export {
  formatOptIns
};
//# sourceMappingURL=format-optins.js.map
